module.exports = __webpack_public_path__ + "static/original-mattress-5-b6347002a9dc094f8f21e2a69c1f1085.webp";